var _defs, _g, _path, _g2, _g3, _g4, _path2, _g5, _g6, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgProgressIcon = function SvgProgressIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 79.753,
    height: 79.753,
    viewBox: "0 0 79.753 79.753"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#16b6bf;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(5.317 5.317)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.28,32A17.28,17.28,0,1,0,66.56,49.28,17.28,17.28,0,0,0,49.28,32Zm0,31.9A14.621,14.621,0,1,1,63.9,49.28,14.639,14.639,0,0,1,49.28,63.9Z",
    transform: "translate(-32 -32)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.6,0a22.6,22.6,0,1,0,22.6,22.6A22.6,22.6,0,0,0,22.6,0Zm0,42.535A19.938,19.938,0,1,1,42.535,22.6,19.961,19.961,0,0,1,22.6,42.535Z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(45.972 8.042)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M287.872,53.65h-6.1l3.37-3.371-1.88-1.88-6.578,6.58,6.578,6.58,1.88-1.88-3.37-3.371h6.1a11.976,11.976,0,0,1,11.963,11.963v6.646h2.658V68.272A14.639,14.639,0,0,0,287.872,53.65Z",
    transform: "translate(-276.688 -48.4)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(7.975 45.193)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M65.9,285.359l-1.88,1.88,3.37,3.371H62.621a11.976,11.976,0,0,1-11.963-11.963V272H48v6.646a14.639,14.639,0,0,0,14.621,14.621h4.767l-3.37,3.371,1.88,1.88,6.578-6.58Z",
    transform: "translate(-48 -272)"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-6.29 12.783)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.216,15.873A5.9,5.9,0,0,1,28.946,17.8,6.518,6.518,0,0,1,23.1,13.388h7.143a1.122,1.122,0,0,0,0-2.243H22.53a9.384,9.384,0,0,1-.068-1.122,9.272,9.272,0,0,1,.087-1.262h7.694a1.122,1.122,0,0,0,0-2.243H23.16a6.483,6.483,0,0,1,5.786-4.276,5.9,5.9,0,0,1,4.269,1.932,1.122,1.122,0,0,0,1.626-1.545A8.117,8.117,0,0,0,28.947,0c-3.739,0-6.935,2.716-8.176,6.519H17.766a1.122,1.122,0,1,0,0,2.243H20.29a11.544,11.544,0,0,0-.071,1.262c0,.38.02.753.056,1.122h-2.51a1.122,1.122,0,1,0,0,2.243h2.961c1.206,3.877,4.435,6.659,8.22,6.659a8.117,8.117,0,0,0,5.895-2.629,1.122,1.122,0,0,0-1.625-1.546Z",
    transform: "translate(0 0)"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M2011.5,43a21.506,21.506,0,0,1-8.369-41.311,21.506,21.506,0,0,1,16.738,39.621A21.364,21.364,0,0,1,2011.5,43Zm0-38a16.5,16.5,0,0,0-11.667,28.167,16.5,16.5,0,1,0,23.334-23.334A16.392,16.392,0,0,0,2011.5,5Z",
    transform: "translate(-1955 36)"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(40 40)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M257.28,240a17.28,17.28,0,1,0,17.28,17.28A17.28,17.28,0,0,0,257.28,240Zm0,31.9A14.621,14.621,0,1,1,271.9,257.28,14.621,14.621,0,0,1,257.28,271.9Z",
    transform: "translate(-240 -240)"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(34.56 34.56)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M230.6,208a22.6,22.6,0,1,0,22.6,22.6A22.6,22.6,0,0,0,230.6,208Zm0,42.535A19.938,19.938,0,1,1,250.535,230.6,19.938,19.938,0,0,1,230.6,250.535Z",
    transform: "translate(-208 -208)"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M-87.708,1082.365v-14.282l8.911-6.465,8.956,6.5v14.249Zm14.993-2.99v-9.863l-6.053-4.39-6.062,4.4v9.856h4.619v-3.608h2.877v3.608Z",
    transform: "translate(135.875 -1016.426)"
  })));
};
export default SvgProgressIcon;